import LastViewedVehicles from '../../../../common/storage/LastViewedVehicles';
import SearchQuery from '../../../../common/storage/SearchQuery';
import EnquiriesSent from '../../../../common/storage/EnquiriesSent';
import Base from './Base';

export default class CookieDataProvider extends Base {
  constructor() {
    super();
  }

  static get lastViewedVehicles() {
    const lastViewedVehicles = new LastViewedVehicles();
    return lastViewedVehicles.data;
  }

  static get hasSearched() {
    const searchQuery = new SearchQuery();
    return searchQuery.data;
  }

  static get sentEnquiries() {
    const enquiriesSent = new EnquiriesSent();
    return enquiriesSent.data;
  }

  static set lastViewedVehicles(value) {
    const lastViewedVehicles = new LastViewedVehicles();
    return lastViewedVehicles.value = value;
  }

  static set hasSearched(value) {
    const searchQuery = new SearchQuery();
    return searchQuery.value = value;
  }

  static set sentEnquiries(value) {
    const enquiriesSent = new EnquiriesSent();
    return enquiriesSent.value = value;
  }
}
